var SignalListener = (function () {
    function SignalListener(name, handler, priority, once) {
        if (priority === void 0) { priority = 0; }
        if (once === void 0) { once = false; }
        this.name = name;
        this.handler = handler;
        this.priority = priority;
        this.once = once;
    }
    return SignalListener;
}());
export default SignalListener;



//////////////////
// WEBPACK FOOTER
// ./src/utils/signals/SignalListener.ts
// module id = null
// module chunks = 